
export default {

  addUtilisateur(state, utilisateur) {
    state.all.unshift(utilisateur)
  },

  setAddresses (state, addresses) {
    state.currentAddresses = addresses
  },

  setCount(state, count) {
    state.count = count
  },

  setCurrentUtilisateur (state, utilisateur) {
    state.current = utilisateur
  },

  setHabilitations (state, habilitations) {
    state.currentHabilitations = habilitations
  },

  setNextUtilisateurs (state, utilisateurs) {    
    state.all = [ ...state.all, ...utilisateurs ]
    state.page++
  },

  setUtilisateurs(state, utilisateurs) {
    state.all = utilisateurs
    state.initialized = true
    state.page = 1
  },

  updateUtilisateur(state, utilisateur) {
    state.all.forEach(( utilisateurIterator, index ) => {
      if ( utilisateurIterator.id === utilisateur.id ) {
        state.all[index] = utilisateur
      }
    });
  }
}